/* eslint-disable react-hooks/exhaustive-deps */
/**
 * Copyright (C) Boost commerce
 * This file is part of commercial Boost commerce projects
 *
 * This file can not be copied and/or distributed without the express
 * permission of Boost commerce
 *
 * Created on Mon 01 Apr 08 2024 14:48:11
 */

//------------------------------------------
import React, { useCallback, useEffect, useState } from 'react';
import moment from 'moment';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { Button, Modal, TextStyle } from '@shopify/polaris';
import { MobileCancelMajor } from '@shopify/polaris-icons';

import { getShop } from 'src/helpers';
import { routes } from 'src/routes';
import history from 'src/routes/history';

import AISearch01 from 'src/assets/images/campaigns/AI-search-campaign-01.svg';
import AISearch02 from 'src/assets/images/campaigns/AI-search-campaign-02.svg';
import AISearch03 from 'src/assets/images/campaigns/AI-search-campaign-03.svg';

const AISearchCampaignPopup = (props: WithI18nProps) => {
  const { i18n } = props;
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState(0);

  const images = [AISearch01, AISearch02, AISearch03];

  let autoDisplay = undefined;

  useEffect(() => {
    try {
      const now = new Date().toLocaleDateString();
      if (moment().startOf().isAfter(moment('2024-04-15 23:59:59'))) {
        return;
      }

      const shop = getShop();
      const lastDisplay = localStorage.getItem(`${shop}-AISearchCampaignPopup0424`);

      // Be already showed today
      if (lastDisplay && lastDisplay === now) {
        return;
      }
      // Display the popup after 3 seconds since users land on the dashboard
      setTimeout(() => {
        setOpen(true);
      }, 3000);
    } catch (error) {}
  }, []);

  useEffect(() => {
    if (open) {
      autoDisplay = setTimeout(() => {
        let currentIndex = current;
        if (currentIndex < images.length - 1) {
          currentIndex += 1;
        } else {
          currentIndex = 0;
        }
        setCurrent(currentIndex);
      }, 3000);
    }
    return () => {
      clearTimeout(autoDisplay);
    };
  }, [open, current]);

  const handleClose = useCallback(() => {
    try {
      const shop = getShop();
      localStorage.setItem(`${shop}-AISearchCampaignPopup0424`, new Date().toLocaleDateString());
    } catch (error) {
    } finally {
      setOpen(false);
    }
  }, []);

  const handleBtnClick = () => {
    history.push(routes.advancedSearch.view());
    handleClose();
  };

  return (
    <Modal
      open={open}
      // onClose={handleClose}
      noScroll
      id="search-campaign-popup"
      titleHidden>
      <div className="ai-search-campaign-popup">
        <div className="ai-search-campaign-title">
          {i18n.translate('AdminHTML.Common.AISearchCampaign0422Popup.title')}
          <div className="ai-search-campaign-btn">
            <Button onClick={handleClose} icon={MobileCancelMajor} plain />
          </div>
        </div>
        <div className="popup-divider" />

        {/* Explore button */}
        <div className="footer">
          <div className="content">
            {i18n.translate('AdminHTML.Common.AISearchCampaign0422Popup.footerContent', {
              t1: (
                <TextStyle variation="strong">
                  {i18n.translate('AdminHTML.Common.AISearchCampaign0422Popup.footerContent_t1')}
                </TextStyle>
              ),
              t2: (
                <span className="highlight">
                  {i18n.translate('AdminHTML.Common.AISearchCampaign0422Popup.footerContent_t2')}
                </span>
              )
            })}
          </div>
          <Button primary size="large" onClick={() => handleBtnClick()}>
            {i18n.translate('AdminHTML.Common.AISearchCampaign0422Popup.actionContent')}
          </Button>
        </div>
        <div className="popup-divider" />
        <div className="campaign-slides">
          {/* Image content */}
          <img
            width={580}
            height={360}
            onClick={() => handleBtnClick()}
            src={images[current]}
            alt={`ai-search-feature-${current + 1}`}
          />

          <div className="actions">
            <div className="dots">
              {images.map((_, index) => (
                <div
                  onClick={() => setCurrent(index)}
                  className={`dot-slider ${current === index ? 'dot-slider--active' : ''}`}
                  key={index}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default withI18n()(AISearchCampaignPopup);
